declare interface ltanalytics {
    track(eventName: string, input: {}): void;
    push(payload: [string,string,{}]): void;
}
import uuidv4 from 'uuid/v4';
import { get as getCookie } from 'es-cookie';
const url = getLocationAbsolutePath();
const timestamp = new Date().valueOf().toString();
var DepositAccount = (<any>window).DepositAccount;

function trackAdImpressions(keyName: string, ads: AdPlacement[]): void {
    if (!ads.length) {
        return;
    }
    ads.forEach((ad: AdPlacement, idx) => {
        ad.position = idx + 1;
        // If tcid is not present, create a new one
        ad.tcid = ad.tcid || createTrackingCorrelationId();
        ad.keyName = keyName || ad.keyName;   // if supplied, override

    });

    DepositAccount = DepositAccount || {};
    DepositAccount.treeBranch = DepositAccount.treeBranch || [];

    //map the ad data with the position of ads
    const mappedAds = ads.map((ad: AdPlacement, idx) => ({
        tcid: ad.tcid,
        data_placement_id: ad.id,
        data_tag_id: ad.tagId,
        data_position: ad.position,
        data_url: url,
        data_section: ad.account.sectionName,
        data_keyName: ad.keyName,
        data_name: ad.account.name,
        data_advertiserName: ad.account.bankName,  
        tree_branch: DepositAccount.treeBranch
    }));
    (<any>window).ltanalytics = (<any>window).ltanalytics || []; 
    ((<any>window).ltanalytics).push(['track','Ad Impression',{"productInfo": mappedAds}]);  
    };


function getLocationAbsolutePath() {
    const href = window.location.href;
    //get the url without query string or fragment
    const url = href.split('?')[0].split('#')[0];
    return url;
}

function formatTrackingLink(link: string) {
    return (link && link.replace("[timestamp]", timestamp));
}

function isCdmaSet(link: string) {
    return link.includes("cdma=1");
};

function trackAdClick(ad: AdPlacement) {
    DepositAccount = DepositAccount || {};
    DepositAccount.treeBranch = DepositAccount.treeBranch || [];

    const url = getLocationAbsolutePath();
    const mappedAds = [{
        tcid: ad.tcid,
        data_placement_id: ad.id,
        data_tag_id: ad.tagId,
        data_position: ad.position,
        data_url: url,
        data_section: ad.account.sectionName,
        data_keyName: ad.keyName,
        data_name: ad.account.name,
        data_advertiserName: ad.account.bankName, 
        tree_branch: DepositAccount.treeBranch
    }];
    (<any>window).ltanalytics = (<any>window).ltanalytics || [];
    ((<any>window).ltanalytics).push(['track','Advertiser Click',{"productInfo": mappedAds}]);   
}

function createTrackingCorrelationId(): string {
    const uniqueId = uuidv4(); //random uuid generation
    const correlationId = uniqueId.replace(/[-]/g, ""); //replace the uuid dashes globally with empty string
    return correlationId;
}

interface RedirectWithCorrelation {
    redirectUrl: string,
    correlationId: string
}

function getRedirectUrlWithParameters(url: string, correlationId: string, geoDma: string | undefined, geoState: string | undefined,
    clickSessionId: string | undefined, mktTrack: string | undefined, ltMktTrack: string | undefined): RedirectWithCorrelation | null {
    //if the url doesn't contain query strings
    if (!url || url.indexOf('?') === -1) {
        return null;
    }

    //get the path on 1 side and query string on other, with possible fragment
    const urlSplit = url.split('?');
    const path = urlSplit[0];
    const qs = urlSplit[1].split('#')[0]; //drop the fragment
    const searchParams = new window.URLSearchParams(qs); //using polyfill for IE
    searchParams.set("tcid", correlationId);
    if (geoDma != undefined) {
        searchParams.set("dma", geoDma);
    }
    if (geoState != undefined) {
        searchParams.set("state", geoState);
    }
    if (clickSessionId != undefined) {
        searchParams.set("clickSessionId", clickSessionId);
    }    
    if (mktTrack != undefined) {        
        searchParams.set("mktTrack", encodeURIComponent(mktTrack));
    }  
    if (ltMktTrack != undefined) {
        searchParams.set("ltMktTrack", encodeURIComponent(ltMktTrack));
    }          
    return {
        redirectUrl: path + '?' + searchParams.toString(),
        correlationId: correlationId
    };
}

const logAdClick = (function () {
    //enclose the clickInProgress to prevent duplicate clicks
    let clickInProgress = false;
    function clearClickInProgress() {
        //clear at half second delay to prevent duplicates
        setTimeout(function () {
            clickInProgress = false;
        }, 500);
    }
    function logAdClickFn(ad: AdPlacement) {
        if (clickInProgress) {
            clearClickInProgress();
            return false;
        }
        clickInProgress = true;
        if (!ad.trackedLink) {
            clickInProgress = false;
            return false;
        }
        const href = formatTrackingLink(ad.trackedLink);
        const isCdma = isCdmaSet(ad.trackedLink); 
        const clickSessionId: string | undefined = isCdma ? getCookie("ClickSessionId") : undefined;
        const mktTrack: string | undefined = isCdma ? getCookie("MKT_TRACK") : undefined;
        const ltMktTrack: string | undefined = isCdma ? getCookie("LT_MKT_TRACK") : undefined;
        const geoDma: string | undefined = getCookie('geodma');
        const geoState: string | undefined = getCookie('geostate');
        const paramsNullable = getRedirectUrlWithParameters(href, ad.tcid, geoDma, geoState, clickSessionId, mktTrack, ltMktTrack);
        if (!paramsNullable) {
            return false;
        }
        const params = <RedirectWithCorrelation>paramsNullable;

        trackAdClick(ad);

        const newTab = window.open(params.redirectUrl, '_blank');
        if (!newTab || newTab.closed) {
            //if popup not open (probably pop up blocker)
            //then need to ensure we log before continuing
            //assuming half second long enough
            setTimeout(function () {
                window.location.href = params.redirectUrl;
                clickInProgress = false;
            }, 500);
            return false;
        }
        newTab.focus();
        clearClickInProgress();
        
        return false;
    }
    return logAdClickFn;
}());

export default {
    trackAdImpressions,
    formatTrackingLink,
    logAdClick,
    createTrackingCorrelationId
};
